import React from 'react';
import { Card, Grid, Button, TextField, styled, Box } from '@mui/material';
// import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import useAuth from 'app/hooks/useAuth';
import { useForm } from 'react-hook-form';
import { getErrorProps, getFieldProps } from '../smart-kit/Form/gridFormUtils';
import { useNavigate } from 'react-router-dom';
import { RtlTextField } from 'app/components/RTLTextField';
import { translate } from 'translate';
import { enqueueSnackbar } from 'notistack';

const FlexBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

const JustifyBox = styled(FlexBox)(() => ({
  justifyContent: 'center',
}));

const NewPasswordRoot = styled(JustifyBox)(() => ({
  background: '#1A2038',
  minHeight: '100vh !important',
  '& .card': {
    maxWidth: 800,
    margin: '1rem',
    borderRadius: 12,
  },
}));

const NewPassword = () => {
  // const classes = useStyles();
  const { newPassword } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const handleFormSubmit = async (values) => {
    try {
      console.log(values);
      await newPassword(values);
      navigate('/');
    } catch (e) {
      console.log(e);
      enqueueSnackbar(e, { variant: 'error' });
      console.log(e);
    }
  };

  return (
    <NewPasswordRoot>
      <Card className="card">
        <Grid container>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <div className="p-8 flex justify-center bg-light-gray items-center h-full">
              <img className="w-full" src="/assets/images/illustrations/posting_photo.svg" alt="" />
            </div>
          </Grid>
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <div className="p-8 h-full ">
              <h4>لطفا رمز عبور جدید انتخاب کنید</h4>
              <br />
              <form onSubmit={handleSubmit(handleFormSubmit)}>
                <RtlTextField
                  type="password"
                  className="mb-4 w-full"
                  {...getErrorProps(errors, 'password')}
                  {...getFieldProps(translate('Password'))}
                  {...register('password', {
                    required: true,
                    minLength: { value: 6, message: 'should be longer than 6 characters' },
                  })}
                />
                <RtlTextField
                  type="password"
                  className="mb-4 w-full"
                  {...getErrorProps(errors, 'confirm_password')}
                  {...getFieldProps(translate('Confirm Password'))}
                  {...register('confirm_password', {
                    required: true,
                    minLength: { value: 6, message: 'should be longer than 6 characters' },
                  })}
                />
                <div className="flex items-center">
                  <Button className="capitalize" variant="contained" color="primary" type="submit">
                    {translate('Set New Password')}
                  </Button>
                </div>
              </form>
            </div>
          </Grid>
        </Grid>
      </Card>
    </NewPasswordRoot>
  );
};

export default NewPassword;
